const staticConst = {
  CASH_BANK: 1,
  SPEND_MONEY: 11,
  RECIEVE_MONEY: 12,
  SEND_TRANSFER: 13,
  RECEIVE_TRANSFER: 14,
  EXPENSE_PAYMENT: 15,
  PURCHASE_PAYMENT: 16,
  CREDIT_CARD: 17,
  RECEIVE_INVOICE_PAYMENT: 17,
  BANK_REVERSAL: 18,
  BANK_OPENING_BALANCE: 19,
  REGISTER_FIXED_ASSET: 20,
  REVERSAL: 21,
  OPENING_BALANCE: 22,
  RECEIVE_ORDER_PAYMENT: 23,
  PURCHASE_ORDER_PAYMENT: 28,
  UNRECONCILED: 31,
  RECONCILED: 32,
  VOID: 113,
  RECEIVE_PROFORMA_PAYMENT: 99,
  APPROVAL_CLOSED: 1,
  APPROVAL_DRAFT: 111,
  APPROVAL_REJECT: 112,
  PURCHASE_JOIN_INVOICE_PAYMENT: 241,
  RECEIVE_JOIN_INVOICE_PAYMENT: 251,
}

const statusColors = [
  { id: staticConst.UNRECONCILED, color: '#CF2A28' },
  { id: staticConst.RECONCILED, color: '#11A428' },
  { id: staticConst.VOID, color: '#ADC2D0' },
  { id: staticConst.APPROVAL_CLOSED, name: 'Closed', color: '#11A428' },
  { id: staticConst.APPROVAL_DRAFT, name: 'Approval Draft', color: '#13A4FF' },
  { id: staticConst.APPROVAL_REJECT, name: 'Reject', color: '#CF2A28' },
]

export { staticConst, statusColors }
